export enum InterestType {
  STANDARD_INTEREST = "STD",
  FIXED_INTEREST = "FIXED",
  NO_INTEREST = "NO",
}

export enum DateFormats {
  REQ = "YYYY-MM-DD",
  MIN_DATE = "0001-01-01",
}

export enum InterestBMD {
  INTEREST_RATE = "InterestRate",
  INTEREST_IN_INVOICE_B2B = "InterestInformationInInvoiceB2B",
  INTEREST_IN_INVOICE_B2C = "InterestInformationInInvoiceB2C",
}

export enum DebtorTypes {
  PERSONAL = "P",
  COMPANY = "N",
}

export enum TransactionTypes {
  INR = "INR",
  IN = "IN",
  DW = "DW",
  OL = "OL",
  CC = "CC",
}

export enum CategoryName {
	INTEREST_DATA = 'InterestData',
	BASIC_DATA = 'BasicData',
}

export enum BmdName {
	INTEREST_PROPERTIES = 'InterestProperties',
	INVOICE_SETTINGS = 'InvoiceSettings',
}

